import { useEffect, useState } from 'react';
import { IMPORTED_TRADES_UPDATED_EVENT, ImportedTradeRecord, loadImportedTrades } from '../utils/importedTradesStorage';
import { privateTradingScopeChangedEventName } from '../lib/storage/privateTradingStorage';

export function useImportedTradesRecords(): ImportedTradeRecord[] {
  const [trades, setTrades] = useState<ImportedTradeRecord[]>(() => {
    if (typeof window === 'undefined') return [];
    return loadImportedTrades();
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const refresh = () => {
      setTrades(loadImportedTrades());
    };
    const handleCustom: EventListener = () => {
      refresh();
    };
    const handleStorage = (event: StorageEvent) => {
      if (!event.key || event.key.startsWith('trade-proof:private:v1:local:') && event.key.endsWith(':imported-trades')) {
        refresh();
      }
    };
    const handleScopeChanged = () => refresh();

    window.addEventListener(IMPORTED_TRADES_UPDATED_EVENT, handleCustom);
    window.addEventListener('storage', handleStorage);
    window.addEventListener(privateTradingScopeChangedEventName(), handleScopeChanged);
    return () => {
      window.removeEventListener(IMPORTED_TRADES_UPDATED_EVENT, handleCustom);
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener(privateTradingScopeChangedEventName(), handleScopeChanged);
    };
  }, []);

  return trades;
}
